import baseApi from './base';
import { ElearningTag, ResourcesTag } from './tags';
import { ResourceMetadataType, ResourceType } from '../types/resource';
import { getAssetLocation } from '@/lib/util';
import { AssetEntityEnum, AssetFileTypeEnum } from '@/modules/types/ckFinder';

interface CreateResourceMetadataType {
  type: ResourceMetadataType;
  url: string;
  position: number;
}

interface CreateResourcePayloadType {
  name: string;
  elearningResourceMetadata: CreateResourceMetadataType;
}

const resourcesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getResources: build.query<ResourceType[], { elearningId: string }>({
      query: (param) => `elearning-resources?elearning-id=${param.elearningId}`,
      transformResponse: (resources: ResourceType[], meta, args) => {
        const { elearningId } = args;
        return resources.map((resource: ResourceType) => {
          const { url } = resource.elearningResourceMetadata;
          return {
            ...resource,
            elearningResourceMetadata: {
              ...resource.elearningResourceMetadata,
              url: url.includes('/')
                ? url
                : getAssetLocation({
                    tenantId: resource.tenantId ? resource.tenantId : '',
                    entityId: elearningId,
                    entity: AssetEntityEnum.elearning,
                    fileType: AssetFileTypeEnum.RESOURCES,
                    fileName: url,
                  }),
            },
          };
        });
      },
      providesTags: [ResourcesTag],
    }),
    postResource: build.mutation<
      CreateResourcePayloadType,
      { elearningId: string; payload: CreateResourcePayloadType }
    >({
      query: ({ elearningId, payload }) => ({
        url: `/elearning-resources/${elearningId}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [ElearningTag],
    }),
    deleteResource: build.mutation<any, string>({
      query: (id) => ({
        url: `/elearning-resources/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ElearningTag],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetResourcesQuery,
  usePostResourceMutation,
  useDeleteResourceMutation,
} = resourcesApi;

export default resourcesApi;
